// Guarda as últimas quadras buscadas no localStorage do navegador (sem banco).
// Ao voltar em "Meus vídeos", a pessoa clica no atalho e já vem estado/cidade/
// arena/quadra preenchidos — só ajusta a data.

export interface RecentCourt {
  state: { id: string; value: string };
  city: { id: string; value: string };
  arena: { id: string; value: string; subCourts?: string[] };
  court: { id: string; value: string };
}

const KEY = 'apertai_recent_courts';
const MAX = 2; // mostra só as 2 últimas buscas

// Chave separada para a página /fasttennis (não mistura com as quadras do /videos)
export const FASTTENNIS_RECENT_KEY = 'apertai_ft_recent_courts';

const keyOf = (r: RecentCourt) =>
  [r.state?.id, r.city?.id, r.arena?.id ?? r.arena?.value, r.court?.value].join('|');

export const getRecentCourts = (storageKey: string = KEY): RecentCourt[] => {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    // filtra entradas incompletas (formato antigo/corrompido)
    return arr.filter((r: any) => r?.state && r?.city && r?.arena && r?.court);
  } catch {
    return [];
  }
};

export const addRecentCourt = (entry: RecentCourt, storageKey: string = KEY) => {
  if (!entry?.state || !entry?.city || !entry?.arena || !entry?.court) return;
  try {
    const clean: RecentCourt = {
      state: { id: entry.state.id, value: entry.state.value },
      city: { id: entry.city.id, value: entry.city.value },
      arena: { id: entry.arena.id, value: entry.arena.value, subCourts: entry.arena.subCourts },
      court: { id: entry.court.id, value: entry.court.value },
    };
    const list = getRecentCourts(storageKey).filter((r) => keyOf(r) !== keyOf(clean));
    list.unshift(clean);
    localStorage.setItem(storageKey, JSON.stringify(list.slice(0, MAX)));
  } catch {
    // localStorage indisponível (modo anônimo etc) — ignora silenciosamente
  }
};

export const removeRecentCourt = (entry: RecentCourt, storageKey: string = KEY) => {
  try {
    const list = getRecentCourts(storageKey).filter((r) => keyOf(r) !== keyOf(entry));
    localStorage.setItem(storageKey, JSON.stringify(list));
  } catch {
    // ignora
  }
};
